"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockLineItemDiscount = exports.mockLineItem = void 0;
const shopify_variant_1 = require("./shopify_variant");
function mockLineItem(overrides = {}) {
    return {
        id: 'Z2lkOi8vc2hvcGlmeS9DaGVja291dExpbmVJdGVtLzMyODE4MzQxNjA5NTY5MD9jaGVja291dD02NDFkYzA4Yzg0OTNhN2UzMTQ3ZTIyMmMyMmU0OGVmOQ==',
        title: 'product title',
        variant: (0, shopify_variant_1.mockShopifyVariant)(),
        quantity: 1,
        discountAllocations: [],
        ...overrides,
    };
}
exports.mockLineItem = mockLineItem;
function mockLineItemDiscount(overrides = {}) {
    return {
        allocatedAmount: {
            amount: '1.23',
            currencyCode: 'USD',
            ...overrides,
        },
    };
}
exports.mockLineItemDiscount = mockLineItemDiscount;
